import script from "./MaintenanceAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./MaintenanceAdmin.vue?vue&type=script&setup=true&lang=js"

import "./MaintenanceAdmin.vue?vue&type=style&index=0&id=6e8e1f73&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e8e1f73"]])

export default __exports__